import { render, staticRenderFns } from "./GoogleRecaptchaText.vue?vue&type=template&id=7921a8c0&scoped=true&"
import script from "./GoogleRecaptchaText.vue?vue&type=script&lang=js&"
export * from "./GoogleRecaptchaText.vue?vue&type=script&lang=js&"
import style0 from "./GoogleRecaptchaText.vue?vue&type=style&index=0&id=7921a8c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921a8c0",
  null
  
)

export default component.exports